import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "atencao-empty"
}
const _hoisted_2 = { class: "agrd-summary" }
const _hoisted_3 = { class: "agrd-total" }
const _hoisted_4 = { class: "agrd-grid" }
const _hoisted_5 = {
  key: 0,
  class: "agrd-fluxo-bar"
}
const _hoisted_6 = { class: "agrd-card-head" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "agrd-contact" }
const _hoisted_10 = { class: "agrd-name" }
const _hoisted_11 = {
  key: 0,
  class: "agrd-phone"
}
const _hoisted_12 = { class: "agrd-id" }
const _hoisted_13 = { class: "agrd-card-body" }
const _hoisted_14 = { class: "agrd-row" }
const _hoisted_15 = { class: "agrd-row" }
const _hoisted_16 = { class: "agrd-pills" }
const _hoisted_17 = { class: "ch-pill" }
const _hoisted_18 = {
  key: 0,
  class: "agrd-wait"
}
const _hoisted_19 = { class: "agrd-created" }
const _hoisted_20 = {
  key: 1,
  class: "agrd-labels"
}
const _hoisted_21 = { class: "agrd-card-foot" }
const _hoisted_22 = ["onClick"]

import { computed, watchEffect } from 'vue'
import type { Conversation } from '@/types/dashboard'
import { avatarColor, initials, fmtWait, fmtChannel, fluxoLabel } from '@/composables/useHelpers'
import { requestOpenChat } from '@/composables/useChatTrigger'


export default /*@__PURE__*/_defineComponent({
  __name: 'AguardandoRespostaTab',
  props: {
    conversations: {},
    active: { type: Boolean },
    toleranceMinutes: {}
  },
  emits: ["updateBadge"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const aguardando = computed(() => {
  const tolMins = Math.max(1, props.toleranceMinutes ?? 10)
  const nowSecs = Date.now() / 1000
  return props.conversations
    .filter(c =>
      (c.status === 'open' || c.status === 'pending') &&
      c.waiting_since > 0 &&
      Math.floor((nowSecs - c.waiting_since) / 60) >= tolMins
    )
    .sort((a, b) => a.waiting_since - b.waiting_since)
})

watchEffect(() => emit('updateBadge', aguardando.value.length))

function statusLabel(s: string): string {
  const map: Record<string, string> = { open: 'Aberta', resolved: 'Resolvida', pending: 'Pendente' }
  return map[s] || s
}

function waitInfo(c: Conversation) {
  return fmtWait(c.waiting_since)
}

function fmtDate(ts: number): string {
  if (!ts) return '—'
  return new Date(ts * 1000).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-pane agrd-pane", { hidden: !__props.active }])
  }, [
    (!aguardando.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "10"
            }),
            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "Nenhuma conversa aguardando", -1)),
          _createElementVNode("small", null, "Conversas com mais de " + _toDisplayString(props.toleranceMinutes ?? 10) + "min de espera aparecerão aqui.", 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "12",
                  cy: "12",
                  r: "10"
                }),
                _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(aguardando.value.length) + " conversa" + _toDisplayString(aguardando.value.length !== 1 ? 's' : '') + " aguardando há mais de " + _toDisplayString(props.toleranceMinutes ?? 10) + "min ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aguardando.value, (c) => {
              return (_openBlock(), _createElementBlock("div", {
                key: c.id,
                class: "agrd-card"
              }, [
                (c.fluxo_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(fluxoLabel)(c.fluxo_id)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "agrd-av",
                    style: _normalizeStyle({ background: _unref(avatarColor)(c.contact.name) })
                  }, [
                    (c.contact.thumbnail)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: c.contact.thumbnail,
                          alt: c.contact.name,
                          style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                          onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
                        }, null, 40, _hoisted_7))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(initials)(c.contact.name)), 1))
                  ], 4),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(c.contact.name), 1),
                    (c.contact.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(c.contact.phone), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_12, "#" + _toDisplayString(c.id), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path></svg>", 1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'agrd-muted': !c.team })
                    }, _toDisplayString(c.team?.name || 'TypeBot'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[5] || (_cache[5] = _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "7",
                        r: "4"
                      })
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'agrd-muted': !c.assignee })
                    }, _toDisplayString(c.assignee?.name || '— sem agente'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["status-pill", c.status])
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sdot" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(statusLabel(c.status)), 1)
                    ], 2),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(fmtChannel)(c.channel)), 1)
                  ]),
                  (waitInfo(c).cls !== 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["wait-badge", waitInfo(c).cls])
                        }, [
                          _cache[7] || (_cache[7] = _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "10"
                            }),
                            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(waitInfo(c).label), 1)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[8] || (_cache[8] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line></svg>", 1)),
                    _createElementVNode("span", null, _toDisplayString(fmtDate(c.created_at)), 1)
                  ]),
                  (c.labels.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.labels, (lbl) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: lbl,
                            class: "label-chip"
                          }, _toDisplayString(lbl.replace(/-|_/g, ' ')), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "agrd-chat-btn",
                    onClick: ($event: any) => (_unref(requestOpenChat)(c.id))
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                    ], -1),
                    _createTextVNode(" Ver Conversa ", -1)
                  ]))], 8, _hoisted_22)
                ])
              ]))
            }), 128))
          ])
        ], 64))
  ], 2))
}
}

})